import * as THREE from 'three';
import BaseMesh from '../BaseMesh.js';

class Index extends BaseMesh {
  constructor(data) {
    super(data);
    const { url, width, height, opacity = 1 } = this.props;
    this.geometry = new THREE.PlaneGeometry(width, height);
    const texture = new THREE.TextureLoader().load(url);
    // 去除黑边
    texture.minFilter = THREE.NearestFilter;
    texture.magFilter = THREE.NearestFilter;
    this.material = new THREE.MeshBasicMaterial({
      map: texture,
      side: THREE.FrontSide,
      transparent: true,
      depthTest: false,
      opacity,
      // color: new THREE.Color(0xffffff00)
    });
  }

  updateProps(key, value) {
    super.updateProps(key, value);
    switch (key) {
      case 'static':
        break;
      case 'url':
        this.material.map = new THREE.TextureLoader().load(value);
        break;
      case 'width':
      case 'height':
        this.geometry = new THREE.PlaneGeometry(this.props.width, this.props.height);
        break;
      case 'opacity':
        this.material.opacity = value;
        break;
    }
  }

  setProps(props) {
    super.setProps(props);
    const { url, width, height, opacity = 1 } = this.props;
    this.geometry = new THREE.PlaneGeometry(width, height);
    this.material = new THREE.MeshBasicMaterial({
      map: new THREE.TextureLoader().load(url),
      side: THREE.FrontSide,
      transparent: true,
      depthTest: false,
      opacity
    });
  }
}

export default Index;
